/* THE DOGS — Funda Mágica ATF 1 — 10453438562604 */
(function(){
'use strict';
if (window.__tdFundaATF1Loaded) return;
window.__tdFundaATF1Loaded=true;

function createFundaCartController(config) {
  'use strict';

  var productId = String(config.productId || '');
  if (!/^\d+$/.test(productId)) throw new Error('Invalid product ID.');

  var root = typeof config.rootPath === 'string' ? config.rootPath : '/';
  if (!/^\/(?!\/)/.test(root) || /[?#\\]/.test(root)) root = '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var PROPERTY = '_td_funda_atf_operation';
  var STORAGE_KEY = 'td-funda-atf:pending:' + productId;
  var POST_TIMEOUT = 15000;
  var READ_TIMEOUT = 10000;
  var EMPTY_GRACE = 30000;
  var memoryPending = null;
  var addInFlight = null;

  function normalizedItems(items) {
    if (!Array.isArray(items) || !items.length) {
      throw new Error('Selecciona al menos una funda.');
    }

    var totals = Object.create(null);

    items.forEach(function (item) {
      var id = Number(item && item.id);
      var quantity = Number(item && item.quantity);

      if (
        !Number.isSafeInteger(id) ||
        id <= 0 ||
        !Number.isSafeInteger(quantity) ||
        quantity <= 0
      ) {
        throw new Error('Revisa las cantidades de tu selección.');
      }

      totals[id] = (totals[id] || 0) + quantity;

      if (!Number.isSafeInteger(totals[id])) {
        throw new Error('Revisa las cantidades de tu selección.');
      }
    });

    return Object.keys(totals).map(function (id) {
      return {
        id: Number(id),
        quantity: totals[id]
      };
    });
  }

  function validatedPending(value) {
    if (
      !value ||
      typeof value.token !== 'string' ||
      !/^[a-zA-Z0-9_-]{8,160}$/.test(value.token)
    ) {
      return null;
    }

    if (!Number.isSafeInteger(value.startedAt) || value.startedAt <= 0) {
      return null;
    }

    try {
      return {
        token: value.token,
        items: normalizedItems(value.items),
        startedAt: value.startedAt,
        persistable: value.persistable !== false
      };
    } catch (error) {
      return null;
    }
  }

  function loadPending() {
    if (memoryPending && memoryPending.persistable === false) {
      return validatedPending(memoryPending);
    }

    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      memoryPending = raw ? validatedPending(JSON.parse(raw)) : null;
    } catch (error) {}

    return memoryPending ? validatedPending(memoryPending) : null;
  }

  function savePending(pending) {
    memoryPending = validatedPending(pending);
    memoryPending.persistable = true;

    try {
      window.sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(memoryPending)
      );

      var saved = JSON.parse(
        window.sessionStorage.getItem(STORAGE_KEY) || 'null'
      );

      if (!saved || saved.token !== memoryPending.token) {
        throw new Error('Storage unavailable.');
      }
    } catch (error) {
      memoryPending.persistable = false;
    }

    return validatedPending(memoryPending);
  }

  function clearPending() {
    memoryPending = null;

    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {}
  }

  function clearMatchingPending(token) {
    var pending = loadPending();

    if (!pending || pending.token === token) {
      clearPending();
    }
  }

  function newToken() {
    var random = '';

    try {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);

      for (var i = 0; i < bytes.length; i += 1) {
        random += ('0' + bytes[i].toString(16)).slice(-2);
      }
    } catch (error) {
      random =
        Math.random().toString(36).slice(2) +
        Math.random().toString(36).slice(2);
    }

    return Date.now().toString(36) + '-' + random;
  }

  async function request(url, options, timeout) {
    var controller =
      typeof AbortController !== 'undefined'
        ? new AbortController()
        : null;

    var timer;
    var timedOut = false;

    var timeoutPromise = new Promise(function (resolve, reject) {
      timer = setTimeout(function () {
        timedOut = true;

        if (controller) {
          controller.abort();
        }

        var error = new Error('Request timed out.');
        error.name = 'TimeoutError';
        reject(error);
      }, timeout);
    });

    var requestOptions = Object.assign(
      {
        credentials: 'same-origin',
        cache: 'no-store'
      },
      options
    );

    if (controller) {
      requestOptions.signal = controller.signal;
    }

    try {
      return await Promise.race([
        (async function () {
          var response = await fetch(url, requestOptions);
          var data = null;

          try {
            data = await response.json();
          } catch (error) {}

          if (timedOut) {
            throw new Error('Request timed out.');
          }

          return {
            ok: response.ok,
            status: response.status,
            data: data
          };
        }()),
        timeoutPromise
      ]);
    } finally {
      clearTimeout(timer);
    }
  }

  async function readCart() {
    var response = await request(
      root + 'cart.js',
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      },
      READ_TIMEOUT
    );

    if (
      !response.ok ||
      !response.data ||
      !Array.isArray(response.data.items)
    ) {
      throw new Error('No pudimos consultar el carrito.');
    }

    return response.data;
  }

  function inspectLines(lines, pending) {
    var expected = Object.create(null);
    var received = Object.create(null);
    var taggedUnits = 0;

    pending.items.forEach(function (item) {
      expected[item.id] = item.quantity;
    });

    lines.forEach(function (line) {
      if (
        !line ||
        !line.properties ||
        line.properties[PROPERTY] !== pending.token
      ) {
        return;
      }

      var id = Number(line.variant_id || line.id);
      var quantity = Number(line.quantity);

      if (
        !Number.isSafeInteger(id) ||
        !Number.isSafeInteger(quantity) ||
        quantity <= 0
      ) {
        return;
      }

      received[id] = (received[id] || 0) + quantity;
      taggedUnits += quantity;
    });

    if (!taggedUnits) {
      return 'none';
    }

    var complete = Object.keys(expected).every(function (id) {
      return received[id] === expected[id];
    });

    var unexpected = Object.keys(received).some(function (id) {
      return !expected[id];
    });

    return complete && !unexpected ? 'confirmed' : 'partial';
  }

  function result(status, cart, pending, message, addResponse) {
    return {
      status: status,
      cart: cart || null,
      pending: pending || null,
      persistable: pending
        ? pending.persistable !== false
        : true,
      message: message || '',
      addResponse: addResponse || null
    };
  }

  function confirmed(cart, pending, addResponse) {
    clearMatchingPending(pending.token);

    return result(
      'confirmed',
      cart,
      null,
      'Las fundas se agregaron al carrito.',
      addResponse
    );
  }

  async function checkPending(pending, options) {
    options = options || {};

    var cart;

    try {
      cart = await readCart();
    } catch (error) {
      return result(
        'unknown',
        null,
        pending,
        'No pudimos comprobar tu última selección. Revisa tu carrito o vuelve a comprobar antes de agregar más fundas.',
        options.addResponse
      );
    }

    var state = inspectLines(cart.items, pending);

    if (state === 'confirmed') {
      return confirmed(cart, pending, options.addResponse);
    }

    if (state === 'partial') {
      return result(
        'partial',
        cart,
        pending,
        'El carrito contiene parte de esta selección o cantidades distintas. Revísalo antes de agregar más fundas.',
        options.addResponse
      );
    }

    var elapsed = Date.now() - pending.startedAt;

    if (
      options.definitelyRejected ||
      (options.allowEmptyReset && elapsed >= EMPTY_GRACE)
    ) {
      clearMatchingPending(pending.token);

      return result(
        'none',
        cart,
        null,
        options.errorMessage ||
          'No encontramos fundas de ese intento en tu carrito. Puedes agregar tu selección nuevamente.',
        options.addResponse
      );
    }

    return result(
      'unknown',
      cart,
      pending,
      'Estamos comprobando tu última selección. Revisa tu carrito o vuelve a comprobar en unos segundos antes de agregar más fundas.',
      options.addResponse
    );
  }

  async function reconcile(value) {
    var pending = validatedPending(value || loadPending());

    if (!pending) {
      return result('none', null, null, '');
    }

    return checkPending(pending, {
      allowEmptyReset: !addInFlight
    });
  }

  async function performAdd(items) {
    var normalized;

    try {
      normalized = normalizedItems(items);
    } catch (error) {
      return result('none', null, null, error.message);
    }

    var previous = loadPending();

    if (previous) {
      return checkPending(previous, {
        allowEmptyReset: true
      });
    }

    var pending = savePending({
      token: newToken(),
      items: normalized,
      startedAt: Date.now()
    });

    var payload = {
      items: pending.items.map(function (item) {
        var properties = {};
        properties[PROPERTY] = pending.token;

        return {
          id: item.id,
          quantity: item.quantity,
          properties: properties
        };
      })
    };

    if (Array.isArray(config.sections)) {
      var sections = config.sections
        .filter(function (id) {
          return typeof id === 'string' && id.length > 0;
        })
        .slice(0, 5);

      if (sections.length) {
        payload.sections = sections;
      }
    }

    if (
      payload.sections &&
      typeof config.sectionsUrl === 'string' &&
      /^\/(?!\/)/.test(config.sectionsUrl)
    ) {
      payload.sections_url = config.sectionsUrl;
    }

    var response;

    try {
      response = await request(
        root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        },
        POST_TIMEOUT
      );
    } catch (error) {
      return checkPending(pending, {
        allowEmptyReset: false
      });
    }

    var addedLines =
      response.data && Array.isArray(response.data.items)
        ? response.data.items
        : [];

    if (
      response.ok &&
      inspectLines(addedLines, pending) === 'confirmed'
    ) {
      return confirmed(null, pending, response.data);
    }

    var definiteClientError = [
      400,
      401,
      403,
      404,
      405,
      406,
      415,
      422
    ].indexOf(response.status) !== -1;

    var description =
      response.data &&
      (response.data.description || response.data.message);

    return checkPending(pending, {
      definitelyRejected:
        !response.ok && definiteClientError,
      allowEmptyReset: false,
      errorMessage:
        typeof description === 'string'
          ? description
          : 'No se agregaron las fundas. Revisa disponibilidad y cantidades e inténtalo nuevamente.',
      addResponse: response.ok ? response.data : null
    });
  }

  function add(items) {
    if (addInFlight) {
      return addInFlight;
    }

    addInFlight = performAdd(items).then(
      function (value) {
        addInFlight = null;
        return value;
      },
      function () {
        addInFlight = null;

        return result(
          'unknown',
          null,
          loadPending(),
          'No pudimos confirmar la selección. Revisa tu carrito antes de volver a agregar fundas.'
        );
      }
    );

    return addInFlight;
  }

  return {
    readCart: readCart,
    add: add,
    reconcile: reconcile,
    loadPending: loadPending,
    clearPending: clearPending
  };
}

function createFundaGallery(root, config) {
  'use strict';

  config = config || {};

  var noop = {
    setColor: function () {},
    destroy: function () {}
  };

  var productId = String(
    config.productId ||
    (root && root.dataset.productId) ||
    ''
  );

  if (!root || productId !== '10453438562604') {
    return noop;
  }

  var sectionId = String(
    config.sectionId ||
    root.dataset.sectionId ||
    ''
  );

  var section = document.getElementById(
    'MainProduct-' + sectionId
  );

  if (!section || !section.contains(root)) {
    return noop;
  }

  var token =
    /\[(?:td-color|td-fm-color)\s*[:=]\s*([^\]]+)\]\s*/ig;

  var groups = new Map();
  var mediaById = new Map();
  var featuredByColor = new Map();
  var colorByFeatured = new Map();
  var originalAttributes = new Map();
  var currentColor = '';
  var applied = false;
  var frame = 0;
  var destroyed = false;
  var media = Array.isArray(config.media)
    ? config.media
    : [];

  var colorIndex = Number(config.colorIndex);

  if (!Number.isInteger(colorIndex) || colorIndex < 0) {
    colorIndex = 1;
  }

  var nativeConfig = {};
  var nativeConfigElement = document.getElementById(
    'VariantMediaConfig-' + sectionId
  );

  if (nativeConfigElement) {
    try {
      nativeConfig =
        JSON.parse(nativeConfigElement.textContent) || {};
    } catch (error) {}
  }

  var nativeFeatured =
    nativeConfig.variantFeaturedMedia || {};

  var nativeGroups =
    nativeConfig.mediaGroups || {};

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function mediaId(value) {
    var match = String(value || '').match(/\d+/g);

    return match && match.length
      ? match[match.length - 1]
      : '';
  }

  function colorToken(value) {
    token.lastIndex = 0;

    var match = token.exec(String(value || ''));

    token.lastIndex = 0;

    if (!match) {
      return '';
    }

    var name = normalize(match[1]);

    return [
      'shared',
      'comun',
      'comunes',
      'todos'
    ].indexOf(name) >= 0
      ? 'shared'
      : name;
  }

  function imageSource(value) {
    if (!value) {
      return '';
    }

    return typeof value === 'string'
      ? value
      : value.src || value.url || '';
  }

  function imageKey(value) {
    try {
      return new URL(
        imageSource(value),
        window.location.href
      ).pathname;
    } catch (error) {
      return '';
    }
  }

  media.forEach(function (item) {
    var id = String(item.id || '');

    if (!id) {
      return;
    }

    mediaById.set(id, item);

    var name = colorToken(item.alt);

    if (name) {
      groups.set(id, name);
    }
  });

  (
    Array.isArray(config.variants)
      ? config.variants
      : []
  ).forEach(function (variant) {
    var name = normalize(
      (variant.options || [])[colorIndex]
    );

    if (!name) {
      return;
    }

    var featured =
      variant.featured_media ||
      variant.featuredMedia;

    var id =
      featured && String(featured.id || '');

    if (!id && variant.featuredMediaId) {
      id = String(variant.featuredMediaId);
    }

    if (!id && nativeFeatured[String(variant.id)]) {
      id = String(
        nativeFeatured[String(variant.id)]
      );
    }

    if (!id && variant.featured_image) {
      var possibleId = String(
        variant.featured_image.id || ''
      );

      if (mediaById.has(possibleId)) {
        id = possibleId;
      }

      if (!id) {
        var key = imageKey(variant.featured_image);

        var found =
          key &&
          media.find(function (item) {
            return imageKey(item.preview_image) === key;
          });

        if (found) {
          id = String(found.id);
        }
      }
    }

    if (!id) {
      return;
    }

    if (!featuredByColor.has(name)) {
      featuredByColor.set(name, []);
    }

    if (
      featuredByColor.get(name).indexOf(id) < 0
    ) {
      featuredByColor.get(name).push(id);
    }

    if (!colorByFeatured.has(id)) {
      colorByFeatured.set(id, name);
    } else if (
      colorByFeatured.get(id) !== name
    ) {
      colorByFeatured.set(id, 'shared');
    }

    if (!groups.has(id)) {
      groups.set(id, name);
    } else if (
      !colorToken(
        (mediaById.get(id) || {}).alt
      ) &&
      groups.get(id) !== name
    ) {
      groups.set(id, 'shared');
    }
  });

  Object.keys(nativeGroups).forEach(function (id) {
    if (groups.has(id)) {
      return;
    }

    var anchor = String(nativeGroups[id] || '');

    if (anchor === 'shared') {
      groups.set(id, 'shared');
    } else if (colorByFeatured.has(anchor)) {
      groups.set(
        id,
        colorByFeatured.get(anchor)
      );
    }
  });

  function remember(element, name) {
    if (!originalAttributes.has(element)) {
      originalAttributes.set(element, {});
    }

    var saved =
      originalAttributes.get(element);

    if (
      !Object.prototype.hasOwnProperty.call(
        saved,
        name
      )
    ) {
      saved[name] =
        element.getAttribute(name);
    }
  }

  function setAttribute(element, name, value) {
    remember(element, name);

    if (value === null) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, value);
    }
  }

  function setClass(element, name, enabled) {
    remember(element, 'class');
    element.classList.toggle(name, enabled);
  }

  function inspectNode(element) {
    var id = mediaId(
      element.dataset.mediaId ||
      element.dataset.target
    );

    var cached =
      element.dataset.tdFundaColor;

    if (cached) {
      groups.set(id, normalize(cached));
    }

    element
      .querySelectorAll('img[alt]')
      .forEach(function (image) {
        var alt =
          image.getAttribute('alt') || '';

        var name = colorToken(alt);

        if (name) {
          groups.set(id, name);
          token.lastIndex = 0;

          setAttribute(
            image,
            'alt',
            alt.replace(token, '').trim()
          );
        }
      });

    return id;
  }

  function hydrate(element) {
    element
      .querySelectorAll(
        '[data-td-funda-srcset], [data-td-funda-src]'
      )
      .forEach(function (image) {
        ['srcset', 'src'].forEach(
          function (attribute) {
            var deferred =
              'data-td-funda-' + attribute;

            var value =
              image.getAttribute(deferred);

            if (!value) {
              return;
            }

            setAttribute(
              image,
              attribute,
              value
            );

            setAttribute(
              image,
              deferred,
              null
            );
          }
        );

        setAttribute(
          image,
          'data-td-funda-network-deferred',
          null
        );
      });
  }

  function visibility(element, visible) {
    setAttribute(
      element,
      'hidden',
      visible ? null : ''
    );

    setAttribute(
      element,
      'aria-hidden',
      visible ? 'false' : 'true'
    );

    remember(element, 'style');
    element.style.display = visible ? '' : 'none';

    setClass(
      element,
      'product__media-item--variant',
      false
    );

    setClass(
      element,
      'thumbnail-list_item--variant',
      false
    );

    if (visible) {
      hydrate(element);
    }
  }

  function isPhoto(element) {
    var item = mediaById.get(
      mediaId(
        element.dataset.mediaId ||
        element.dataset.target
      )
    );

    if (item && item.media_type) {
      return item.media_type === 'image';
    }

    return !element.querySelector(
      'deferred-media, video, iframe, model-viewer, .thumbnail__badge'
    );
  }

  function galleries() {
    return Array.from(
      section.querySelectorAll('media-gallery')
    ).filter(function (gallery) {
      return (
        !gallery.dataset.tdOfferGallery ||
        gallery.dataset.tdOfferGallery === 'solo'
      );
    });
  }

  function shouldShow(id) {
    var name = groups.get(id);

    return (
      !name ||
      name === 'shared' ||
      name === currentColor
    );
  }

  function pause(element, gallery) {
    element
      .querySelectorAll('deferred-media')
      .forEach(function (deferred) {
        if (
          typeof gallery.pauseDeferredMedia ===
          'function'
        ) {
          gallery.pauseDeferredMedia(deferred);
        }
      });

    element
      .querySelectorAll('video')
      .forEach(function (video) {
        try {
          video.pause();
        } catch (error) {}
      });
  }

  function filterGallery(gallery) {
    var slides = Array.from(
      gallery.querySelectorAll(
        '.product__media-item[data-media-id]'
      )
    );

    var thumbs = Array.from(
      gallery.querySelectorAll(
        '.thumbnail-list__item[data-target]'
      )
    );

    if (!slides.length) {
      return;
    }

    slides.concat(thumbs).forEach(inspectNode);

    var visible = slides.filter(
      function (slide) {
        return shouldShow(
          mediaId(slide.dataset.mediaId)
        );
      }
    );

    if (!visible.length) {
      visible = slides.slice();
    }

    var visibleIds = new Set(
      visible.map(function (slide) {
        return mediaId(
          slide.dataset.mediaId
        );
      })
    );

    var preferredIds =
      featuredByColor.get(currentColor) || [];

    var hero =
      visible.find(function (slide) {
        var item =
          mediaById.get(
            mediaId(slide.dataset.mediaId)
          ) || {};

        return (
          isPhoto(slide) &&
          colorToken(item.alt) === currentColor
        );
      }) ||
      visible.find(function (slide) {
        return (
          isPhoto(slide) &&
          preferredIds.indexOf(
            mediaId(slide.dataset.mediaId)
          ) >= 0
        );
      }) ||
      visible.find(function (slide) {
        return (
          isPhoto(slide) &&
          groups.get(
            mediaId(slide.dataset.mediaId)
          ) === currentColor
        );
      }) ||
      visible.find(isPhoto) ||
      visible[0];

    slides.forEach(function (slide) {
      visibility(
        slide,
        visibleIds.has(
          mediaId(slide.dataset.mediaId)
        )
      );

      setClass(
        slide,
        'is-active',
        slide === hero
      );

      if (slide !== hero) {
        pause(slide, gallery);
      }
    });

    var activeThumb = null;

    thumbs.forEach(function (thumb) {
      var id = mediaId(thumb.dataset.target);

      visibility(
        thumb,
        visibleIds.has(id)
      );

      var active =
        id === mediaId(hero.dataset.mediaId);

      setClass(
        thumb,
        'is-active-media-thumbnail',
        active
      );

      setClass(
        thumb,
        'is-thumbnail-sequence-hidden',
        false
      );

      var button =
        thumb.querySelector('button');

      if (button) {
        setAttribute(
          button,
          'aria-current',
          active ? 'true' : null
        );
      }

      if (active) {
        activeThumb = thumb;
      }
    });

    var viewer = gallery.querySelector(
      '[id^="GalleryViewer-"]'
    );

    var thumbnails = gallery.querySelector(
      '[id^="GalleryThumbnails-"]'
    );

    var viewerList =
      viewer &&
      (
        viewer.slider ||
        viewer.querySelector(
          '.product__media-list'
        )
      );

    [viewer, thumbnails].forEach(
      function (slider) {
        if (!slider) {
          return;
        }

        slider
          .querySelectorAll('.slider-button')
          .forEach(function (button) {
            setAttribute(
              button,
              'disabled',
              visible.length < 2 ? '' : null
            );

            setAttribute(
              button,
              'aria-disabled',
              visible.length < 2
                ? 'true'
                : 'false'
            );
          });
      }
    );

    if (viewerList) {
      viewerList.scrollLeft = hero.offsetLeft;

      if (
        typeof viewer.resetPages ===
        'function'
      ) {
        viewer.resetPages();
      } else if (
        typeof viewer.initPages ===
        'function'
      ) {
        viewer.initPages();
      }
    }

    if (
      typeof gallery.updateActiveThumbnailVisibility ===
      'function'
    ) {
      gallery.updateActiveThumbnailVisibility(
        activeThumb
      );
    }

    if (thumbnails) {
      if (thumbnails.slider) {
        thumbnails.slider.scrollLeft = 0;
      }

      if (
        typeof thumbnails.resetPages ===
        'function'
      ) {
        thumbnails.resetPages();
      } else if (
        typeof thumbnails.initPages ===
        'function'
      ) {
        thumbnails.initPages();
      }
    }

    var currentCounter =
      viewer &&
      viewer.querySelector(
        '.slider-counter--current'
      );

    var totalCounter =
      viewer &&
      viewer.querySelector(
        '.slider-counter--total'
      );

    if (currentCounter) {
      currentCounter.textContent = String(
        visible.indexOf(hero) + 1
      );
    }

    if (totalCounter) {
      totalCounter.textContent = String(
        visible.length
      );
    }

    if (visible.length === 1 && viewer) {
      viewer
        .querySelectorAll('.slider-button')
        .forEach(function (button) {
          setAttribute(
            button,
            'disabled',
            ''
          );
        });
    }

    [viewer, thumbnails].forEach(
      function (slider) {
        if (!slider) {
          return;
        }

        slider
          .querySelectorAll('.slider-button')
          .forEach(function (button) {
            setAttribute(
              button,
              'aria-disabled',
              button.disabled
                ? 'true'
                : 'false'
            );
          });
      }
    );

    if (
      typeof gallery.scheduleDesktopViewerNavigationSync ===
      'function'
    ) {
      gallery.scheduleDesktopViewerNavigationSync();
    }
  }

  function filterModal() {
    var modal = document.getElementById(
      'ProductModal-' + sectionId
    );

    if (!modal) {
      return;
    }

    var nodes = Array.from(
      modal.querySelectorAll(
        '.product-media-modal__content > [data-media-id]'
      )
    ).filter(function (node) {
      return (
        !node.dataset.tdOfferMedia ||
        node.dataset.tdOfferMedia === 'solo'
      );
    });

    nodes.forEach(inspectNode);

    var visible = nodes.filter(function (node) {
      return shouldShow(
        mediaId(node.dataset.mediaId)
      );
    });

    if (!visible.length) {
      visible = nodes.slice();
    }

    nodes.forEach(function (node) {
      visibility(
        node,
        visible.indexOf(node) >= 0
      );
    });

    if (
      typeof modal.refreshMedia === 'function'
    ) {
      modal.refreshMedia();
    }
  }

  function apply() {
    frame = 0;

    if (
      destroyed ||
      !currentColor ||
      !root.isConnected
    ) {
      return;
    }

    var activeGalleries = galleries();

    activeGalleries.forEach(filterGallery);
    applied = activeGalleries.length > 0;
    filterModal();
  }

  function setColor(color) {
    if (destroyed) {
      return;
    }

    var next = normalize(color);

    if (!next) {
      return;
    }

    if (next === currentColor && applied) {
      return;
    }

    currentColor = next;

    if (frame) {
      window.cancelAnimationFrame(frame);
    }

    frame = window.requestAnimationFrame(apply);
  }

  function modalBuilt(event) {
    if (destroyed || !currentColor) {
      return;
    }

    var detail = event.detail || {};

    if (
      String(detail.sectionId || '') ===
      sectionId
    ) {
      filterModal();
    }
  }

  document.addEventListener(
    'td:product-modal-built',
    modalBuilt
  );

  return {
    setColor: setColor,

    destroy: function () {
      if (destroyed) {
        return;
      }

      destroyed = true;

      if (frame) {
        window.cancelAnimationFrame(frame);
      }

      document.removeEventListener(
        'td:product-modal-built',
        modalBuilt
      );

      originalAttributes.forEach(
        function (attributes, element) {
          Object.keys(attributes).forEach(
            function (name) {
              if (attributes[name] === null) {
                element.removeAttribute(name);
              } else {
                element.setAttribute(
                  name,
                  attributes[name]
                );
              }
            }
          );
        }
      );

      originalAttributes.clear();
    }
  };
}

function mountFundaATF(root) {
  if (
    !root ||
    root.dataset.productId !==
      '10453438562604' ||
    root.dataset.fmMounted === 'true'
  ) {
    return;
  }

  var config;

  try {
    config = JSON.parse(
      root.querySelector(
        '[data-fm-config]'
      ).textContent
    );
  } catch (error) {
    return;
  }

  if (
    String(config.productId) !==
    '10453438562604'
  ) {
    return;
  }

  var variants = Array.isArray(config.variants)
    ? config.variants
    : [];

  var options = (config.options || []).map(
    function (option) {
      return typeof option === 'string'
        ? option
        : option.name;
    }
  );

  var colorIndex = options.findIndex(
    function (option) {
      return /color|tono/i.test(option);
    }
  );

  if (colorIndex < 0 || variants.length === 0) {
    return;
  }

  var types = [
    'seat',
    'back',
    'chaise'
  ];

  var labels = {
    seat: 'asiento',
    back: 'respaldo',
    chaise: 'chaise'
  };

  var plural = {
    seat: 'asientos',
    back: 'respaldos',
    chaise: 'chaise'
  };

  function normal(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHTML(value) {
    return String(
      value == null ? '' : value
    ).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function kind(variant) {
    var title = (variant.options || [])
      .filter(function (_, index) {
        return index !== colorIndex;
      })
      .join(' ');

    if (/chaise|lateral|seccional/i.test(title)) {
      return 'chaise';
    }

    if (/respaldo/i.test(title)) {
      return 'back';
    }

    if (/asiento/i.test(title)) {
      return 'seat';
    }

    return '';
  }

  if (
    variants.some(function (variant) {
      return (
        !kind(variant) ||
        /\b[2-9]\d*\s*fundas?\b|\bpack\b/i.test(
          (variant.options || [])
            .filter(function (_, index) {
              return index !== colorIndex;
            })
            .join(' ')
        )
      );
    })
  ) {
    return;
  }

  var lookup = {};
  var colors = [];
  var ambiguous = false;

  variants.forEach(function (variant) {
    var color =
      (variant.options || [])[colorIndex];

    if (!color) {
      ambiguous = true;
      return;
    }

    var key =
      kind(variant) + ':' + normal(color);

    if (lookup[key]) {
      ambiguous = true;
    }

    lookup[key] = variant;

    if (
      !colors.some(function (name) {
        return normal(name) === normal(color);
      })
    ) {
      colors.push(color);
    }
  });

  if (
    ambiguous ||
    !types.every(function (type) {
      return variants.some(function (variant) {
        return kind(variant) === type;
      });
    })
  ) {
    return;
  }

  config.colorIndex = colorIndex;

  function find(type, color) {
    return (
      lookup[type + ':' + normal(color)] ||
      null
    );
  }

  function q(selector) {
    return root.querySelector(selector);
  }

  function all(selector) {
    return Array.from(
      root.querySelectorAll(selector)
    );
  }

  function money(cents) {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: config.currency || 'CLP',
      maximumFractionDigits:
        (config.currency || 'CLP') === 'CLP'
          ? 0
          : 2
    }).format(Number(cents || 0) / 100);
  }

  function safeImage(src, width) {
    if (!src) {
      return '';
    }

    try {
      var url = new URL(
        src,
        window.location.href
      );

      if (
        url.protocol !== 'https:' &&
        url.protocol !== 'http:'
      ) {
        return '';
      }

      url.searchParams.set(
        'width',
        String(width)
      );

      return url.href;
    } catch (error) {
      return '';
    }
  }

  function imageFor(color) {
    var media = config.media || [];

    var tagged = media.find(function (item) {
      var match = String(
        item.alt || ''
      ).match(
        /\[(?:td-color|td-fm-color)\s*[:=]\s*([^\]]+)\]/i
      );

      return (
        item.media_type === 'image' &&
        match &&
        normal(match[1]) === normal(color)
      );
    });

    if (tagged) {
      return (
        (tagged.preview_image || {}).src ||
        tagged.src ||
        ''
      );
    }

    var variant = variants.find(
      function (item) {
        return (
          normal(item.options[colorIndex]) ===
            normal(color) &&
          item.featured_image
        );
      }
    );

    if (variant) {
      return typeof variant.featured_image ===
        'string'
        ? variant.featured_image
        : variant.featured_image.src || '';
    }

    return '';
  }

  var selected =
    variants.find(function (variant) {
      return (
        Number(variant.id) ===
        Number(config.selectedVariantId)
      );
    }) ||
    variants.find(function (variant) {
      return variant.available;
    }) ||
    variants[0];

  var state = {
    color: selected.options[colorIndex],
    quantities: {
      seat: 0,
      back: 0,
      chaise: 0
    },
    overrides: {
      seat: '',
      back: '',
      chaise: ''
    },
    backExpanded: false
  };

  var stateKey =
    'td-funda-atf:selection:' +
    config.productId;

  var urlVariant =
    new URL(window.location.href)
      .searchParams
      .get('variant') || '';

  try {
    var saved = JSON.parse(
      window.sessionStorage.getItem(stateKey) ||
      'null'
    );

    if (
      saved &&
      saved.urlVariant === urlVariant &&
      colors.indexOf(saved.color) >= 0
    ) {
      state.color = saved.color;

      types.forEach(function (type) {
        var value = Number(
          (saved.quantities || {})[type]
        );

        state.quantities[type] =
          Number.isInteger(value) &&
          value >= 0 &&
          value <= 99
            ? value
            : 0;

        var override =
          (saved.overrides || {})[type];

        state.overrides[type] =
          colors.indexOf(override) >= 0
            ? override
            : '';
      });

      state.backExpanded =
        !!saved.backExpanded;
    }
  } catch (error) {}

  function saveState() {
    try {
      window.sessionStorage.setItem(
        stateKey,
        JSON.stringify(
          Object.assign(
            {
              urlVariant: urlVariant
            },
            state
          )
        )
      );
    } catch (error) {}
  }

  function colorFor(type) {
    return (
      state.overrides[type] ||
      state.color
    );
  }

  var busy = false;
  var recovery = null;
  var epoch = 0;
  var destroyed = false;
  var cleanups = [];
  var announcementTimer;
  var scrollFrame = 0;

  var cartUI =
    document.querySelector('cart-drawer') ||
    document.querySelector(
      'cart-notification'
    );

  var sections = [
    'cart-drawer',
    'cart-icon-bubble'
  ];

  if (
    cartUI &&
    typeof cartUI.getSectionsToRender ===
      'function'
  ) {
    try {
      sections = cartUI
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        });
    } catch (error) {}
  }

  var cart = createFundaCartController({
    productId: config.productId,
    rootPath: config.rootPath,
    sections: sections,
    sectionsUrl: window.location.pathname
  });

  var gallery = createFundaGallery(
    root,
    config
  );

  var guide = q('[data-fm-guide]');
  var guideOpener = null;

  var section = document.getElementById(
    'MainProduct-' + config.sectionId
  );

  q('[data-fm-swatches]').innerHTML =
    colors.map(function (color) {
      var image = safeImage(
        imageFor(color),
        150
      );

      return (
        '<button type="button" class="td-fm-atf__swatch" data-fm-color="' +
        escapeHTML(color) +
        '" aria-label="' +
        escapeHTML(color) +
        '" title="' +
        escapeHTML(color) +
        '" aria-pressed="false">' +
        (
          image
            ? '<img src="' +
              escapeHTML(image) +
              '" width="80" height="80" loading="lazy" decoding="async" alt="' +
              escapeHTML(color) +
              '">'
            : '<span>' +
              escapeHTML(color) +
              '</span>'
        ) +
        '</button>'
      );
    }).join('');

  q('[data-fm-custom-selects]').innerHTML =
    types.map(function (type) {
      var title =
        type === 'chaise'
          ? 'Chaise'
          : plural[type]
              .charAt(0)
              .toUpperCase() +
            plural[type].slice(1);

      return (
        '<label>' +
        escapeHTML(title) +
        '<select data-fm-custom="' +
        type +
        '" aria-label="Color de ' +
        escapeHTML(plural[type]) +
        '">' +
        '<option value="">Color del conjunto</option>' +
        colors.map(function (color) {
          return (
            '<option value="' +
            escapeHTML(color) +
            '">' +
            escapeHTML(color) +
            '</option>'
          );
        }).join('') +
        '</select></label>'
      );
    }).join('');

  var reviewed =
    document.createElement('button');

  reviewed.type = 'button';
  reviewed.className =
    'td-fm-atf__text-button';

  reviewed.setAttribute(
    'data-fm-reviewed',
    ''
  );

  reviewed.textContent =
    'Ya revisé mi carrito, continuar';

  q('[data-fm-recovery]')
    .appendChild(reviewed);

  function selection() {
    var lines = [];
    var problems = [];

    types.forEach(function (type) {
      var quantity =
        state.quantities[type];

      if (!quantity) {
        return;
      }

      var color = colorFor(type);
      var variant = find(type, color);

      if (!variant || !variant.available) {
        problems.push(
          'La funda de ' +
          labels[type] +
          ' en ' +
          color +
          ' no está disponible. Cambia ese color o quita esa pieza.'
        );
      }

      if (variant) {
        lines.push({
          type: type,
          color: color,
          quantity: quantity,
          variant: variant,
          total:
            Number(variant.price) *
            quantity
        });
      }
    });

    return {
      lines: lines,
      errors: problems,

      count: types.reduce(
        function (sum, type) {
          return (
            sum +
            state.quantities[type]
          );
        },
        0
      ),

      total: lines.reduce(
        function (sum, line) {
          return sum + line.total;
        },
        0
      ),

      before: lines.reduce(
        function (sum, line) {
          return (
            sum +
            Math.max(
              Number(
                line.variant
                  .compare_at_price || 0
              ),
              Number(line.variant.price)
            ) *
            line.quantity
          );
        },
        0
      )
    };
  }

  function setMessage(message) {
    q('[data-fm-error]').textContent =
      message || '';

    q('[data-fm-error]').hidden =
      !message;
  }

  function announce(message) {
    clearTimeout(announcementTimer);

    announcementTimer = setTimeout(
      function () {
        if (!destroyed) {
          q('[data-fm-live]').textContent =
            message;
        }
      },
      150
    );
  }

  function emit(name, detail) {
    var payload = Object.assign(
      {
        event: name,
        product_id: config.productId
      },
      detail || {}
    );

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(payload);
      }
    } catch (error) {}

    try {
      root.dispatchEvent(
        new CustomEvent(
          name.replace(/_/g, ':'),
          {
            bubbles: true,
            detail: payload
          }
        )
      );
    } catch (error) {}
  }

  function scheduleSticky() {
    if (scrollFrame || destroyed) {
      return;
    }

    scrollFrame =
      window.requestAnimationFrame(
        function () {
          scrollFrame = 0;
          refreshSticky();
        }
      );
  }

  function refreshSticky() {
    var node = q('[data-fm-sticky]');

    if (
      !section ||
      window.innerWidth >= 750 ||
      guide.open
    ) {
      node.hidden = true;
      return;
    }

    var rect =
      section.getBoundingClientRect();

    var button =
      q('[data-fm-submit]')
        .getBoundingClientRect();

    var height = window.innerHeight;

    var mainButtonVisible =
      button.top < height - 20 &&
      button.bottom > 80;

    node.hidden =
      mainButtonVisible ||
      rect.top > height ||
      rect.bottom < 100;
  }

  function render() {
    if (destroyed) {
      return;
    }

    var selectionState = selection();

    var entry = variants.filter(
      function (variant) {
        return (
          variant.available &&
          normal(
            variant.options[colorIndex]
          ) === normal(state.color) &&
          (
            kind(variant) === 'seat' ||
            kind(variant) === 'back'
          )
        );
      }
    );

    if (!entry.length) {
      entry = variants.filter(
        function (variant) {
          return variant.available;
        }
      );
    }

    var entryMinimum = entry.length
      ? Math.min.apply(
          null,
          entry.map(function (variant) {
            return Number(variant.price);
          })
        )
      : 0;

    var entryHasVerifiedSale = entry.some(
      function (variant) {
        return (
          Number(variant.price) === entryMinimum &&
          Number(variant.compare_at_price || 0) >
            Number(variant.price)
        );
      }
    );

    q('[data-fm-entry-cyber-price-label]').hidden =
      !entryHasVerifiedSale;

    q('[data-fm-entry-price]').textContent =
      entry.length
        ? money(
            Math.min.apply(
              null,
              entry.map(function (variant) {
                return Number(
                  variant.price
                );
              })
            )
          )
        : 'Agotado';

    q('[data-fm-entry-unit]').textContent =
      'por funda';

    q('[data-fm-color-name]').textContent =
      state.color;

    all('[data-fm-color]').forEach(
      function (button) {
        var color =
          button.getAttribute(
            'data-fm-color'
          );

        var available = variants.some(
          function (variant) {
            return (
              variant.available &&
              normal(
                variant.options[colorIndex]
              ) === normal(color)
            );
          }
        );

        button.setAttribute(
          'aria-pressed',
          String(
            normal(color) ===
            normal(state.color)
          )
        );

        button.dataset.unavailable =
          String(!available);

        button.disabled =
          busy || !available;

        button.title =
          color +
          (
            available
              ? ''
              : ' · Agotado'
          );
      }
    );

    types.forEach(function (type) {
      var variant = find(
        type,
        colorFor(type)
      );

      var available =
        !!(variant && variant.available);

      q(
        '[data-fm-unit="' +
        type +
        '"]'
      ).textContent = variant
        ? money(variant.price) +
          ' por funda'
        : 'Sin variante para este color';

      var input = q(
        '[data-fm-qty="' +
        type +
        '"]'
      );

      input.value =
        state.quantities[type];

      input.disabled =
        busy ||
        (
          !available &&
          state.quantities[type] === 0
        );

      q(
        '[data-fm-step="' +
        type +
        ':-1"]'
      ).disabled =
        busy ||
        state.quantities[type] === 0;

      q(
        '[data-fm-step="' +
        type +
        ':1"]'
      ).disabled =
        busy ||
        !available ||
        state.quantities[type] >= 99;

      var stock = q(
        '[data-fm-stock="' +
        type +
        '"]'
      );

      stock.textContent = available
        ? ''
        : 'No disponible en ' +
          colorFor(type) +
          '. Puedes elegir otro color.';

      stock.hidden = available;

      var custom = q(
        '[data-fm-custom="' +
        type +
        '"]'
      );

      custom.value =
        state.overrides[type];

      custom.disabled = busy;

      Array.from(custom.options)
        .forEach(function (option) {
          if (!option.value) {
            option.textContent =
              'Color del conjunto · ' +
              state.color;

            return;
          }

          var optionVariant = find(
            type,
            option.value
          );

          option.disabled =
            !optionVariant ||
            !optionVariant.available;

          option.textContent =
            option.value +
            (
              option.disabled
                ? ' · Agotado'
                : ''
            );
        });
    });

    all('[data-fm-seat-count]').forEach(
      function (button) {
        button.setAttribute(
          'aria-pressed',
          String(
            Number(
              button.dataset.fmSeatCount
            ) ===
            state.quantities.seat
          )
        );

        var variant = find(
          'seat',
          colorFor('seat')
        );

        button.disabled =
          busy ||
          !variant ||
          !variant.available;
      }
    );

    q('[data-fm-other-qty]').disabled =
      busy;

    var backColor = colorFor('back');
    var back = find('back', backColor);

    var suggested = Math.max(
      1,
      Math.min(
        99,
        state.quantities.seat +
        state.quantities.chaise
      )
    );

    var activeBase =
      state.quantities.seat +
      state.quantities.chaise >
      0;

    var matchingColors =
      normal(backColor) ===
        normal(colorFor('seat')) &&
      (
        !state.quantities.chaise ||
        normal(backColor) ===
          normal(colorFor('chaise'))
      );

    var showOffer =
      activeBase &&
      state.quantities.back === 0 &&
      !state.backExpanded;

    q('[data-fm-back-offer]').hidden =
      !showOffer;

    q(
      '[data-fm-back-quantity]'
    ).hidden =
      state.quantities.back === 0 &&
      !state.backExpanded;

    q('[data-fm-back-state]').textContent =
      state.quantities.back
        ? 'Respaldos incluidos'
        : 'Respaldos';

    q(
      '[data-fm-back-eyebrow]'
    ).textContent =
      state.quantities.back
        ? 'Tu selección de respaldos'
        : activeBase
          ? 'Completa con respaldos'
          : 'También para tus respaldos';

    q(
      '[data-fm-piece="back"] h3'
    ).textContent =
      !activeBase &&
      state.quantities.back
        ? 'Fundas para tus respaldos'
        : matchingColors
          ? 'El mismo tono, arriba y abajo'
          : 'Completa también los respaldos';

    q(
      '[data-fm-back-copy]'
    ).textContent =
      state.quantities.back
        ? 'Cantidad y color editables para que cada cojín tenga su funda.'
        : activeBase
          ? 'Combínalos en ' +
            backColor +
            '. Ajusta la cantidad según tus cojines.'
          : 'Combina fundas de asiento y respaldo para un acabado uniforme.';

    q(
      '[data-fm-back-add-price]'
    ).textContent = back
      ? '+' +
        money(
          Number(back.price) *
          suggested
        )
      : 'No disponible';

    q(
      '[data-fm-back-add-count]'
    ).textContent =
      'por ' +
      suggested +
      ' funda' +
      (
        suggested === 1
          ? ''
          : 's'
      ) +
      ' de respaldo';

    q('[data-fm-add-backs]').textContent =
      'Añadir ' +
      suggested +
      ' respaldo' +
      (
        suggested === 1
          ? ''
          : 's'
      );

    q('[data-fm-add-backs]').disabled =
      busy ||
      !back ||
      !back.available;

    q('[data-fm-edit-backs]').hidden =
      state.quantities.back > 0 ||
      state.backExpanded;

    q('[data-fm-edit-backs]').disabled =
      busy;

    q('[data-fm-remove-backs]').hidden =
      state.quantities.back === 0;

    q(
      '[data-fm-remove-backs]'
    ).disabled = busy;

    q(
      '[data-fm-piece="back"]'
    ).classList.toggle(
      'is-selected',
      state.quantities.back > 0
    );

    var image = safeImage(
      imageFor(backColor),
      240
    );

    var backImage = q(
      '[data-fm-back-image]'
    );

    if (
      image &&
      backImage.getAttribute('src') !==
        image
    ) {
      backImage.src = image;
    }

    backImage.alt =
      'Funda Mágica en ' + backColor;

    backImage.hidden = !image;

    q(
      '[data-fm-chaise-summary]'
    ).textContent =
      state.quantities.chaise
        ? state.quantities.chaise +
          ' seleccionada' +
          (
            state.quantities.chaise === 1
              ? ''
              : 's'
          )
        : 'Añadir chaise';

    q('[data-fm-summary]').hidden =
      !selectionState.count;

    q('[data-fm-empty]').hidden =
      !!selectionState.count;

    q('[data-fm-unit-count]').textContent =
      selectionState.count +
      ' funda' +
      (
        selectionState.count === 1
          ? ''
          : 's'
      );

    q(
      '[data-fm-summary-lines]'
    ).innerHTML =
      selectionState.lines.map(
        function (line) {
          return (
            '<li><span>' +
            line.quantity +
            ' ' +
            (
              line.quantity === 1
                ? labels[line.type]
                : plural[line.type]
            ) +
            '<small>' +
            escapeHTML(line.color) +
            '</small></span><span>' +
            money(line.total) +
            '</span></li>'
          );
        }
      ).join('');

    q('[data-fm-total]').textContent =
      selectionState.errors.length
        ? 'Revisa selección'
        : money(selectionState.total);

    q('[data-fm-compare]').hidden =
      selectionState.errors.length > 0 ||
      selectionState.before <=
        selectionState.total;

    q('[data-fm-cyber-price-label]').hidden =
      selectionState.errors.length > 0 ||
      selectionState.before <=
        selectionState.total;

    q('[data-fm-compare]').innerHTML =
      'Antes <s>' +
      money(selectionState.before) +
      '</s>';

    var button = q('[data-fm-submit]');

    var anyAvailable = variants.some(
      function (variant) {
        return variant.available;
      }
    );

    button.disabled =
      busy ||
      !!recovery ||
      selectionState.errors.length > 0 ||
      !anyAvailable;

    button.textContent = busy
      ? 'Agregando…'
      : recovery
        ? 'Comprueba tu carrito'
        : !anyAvailable
          ? 'Agotado'
          : selectionState.errors.length
            ? 'Revisa el color de tus fundas'
            : selectionState.count
              ? 'Agregar ' +
                selectionState.count +
                ' funda' +
                (
                  selectionState.count === 1
                    ? ''
                    : 's'
                ) +
                ' · ' +
                money(selectionState.total)
              : 'Elegir cantidad';

    button.setAttribute(
      'aria-busy',
      String(busy)
    );

    q(
      '[data-fm-sticky-total]'
    ).textContent =
      selectionState.count &&
      !selectionState.errors.length
        ? money(selectionState.total)
        : q(
            '[data-fm-entry-price]'
          ).textContent;

    q('[data-fm-sticky-cyber-price-label]').hidden =
      selectionState.count
        ? selectionState.errors.length > 0 ||
          selectionState.before <=
            selectionState.total
        : !entryHasVerifiedSale;

    q(
      '[data-fm-sticky-count]'
    ).textContent =
      selectionState.count
        ? selectionState.count +
          ' funda' +
          (
            selectionState.count === 1
              ? ''
              : 's'
          ) +
          ' seleccionada' +
          (
            selectionState.count === 1
              ? ''
              : 's'
          )
        : 'Elige las piezas de tu sofá';

    q(
      '[data-fm-sticky-submit]'
    ).textContent = busy
      ? 'Agregando…'
      : recovery
        ? 'Revisar carrito'
        : !anyAvailable
          ? 'Agotado'
          : selectionState.count &&
            !selectionState.errors.length
            ? 'Agregar al carrito'
            : 'Elegir fundas';

    q(
      '[data-fm-sticky-submit]'
    ).disabled =
      busy || !anyAvailable;

    q('[data-fm-recovery]').hidden =
      !recovery;

    q('[data-fm-recheck]').disabled =
      busy;

    reviewed.disabled = busy;

    if (
      selectionState.errors.length &&
      !recovery &&
      !busy
    ) {
      setMessage(
        selectionState.errors.join(' ')
      );
    }

    saveState();
    scheduleSticky();
  }

  function setQuantity(type, value) {
    if (
      busy ||
      types.indexOf(type) < 0
    ) {
      return;
    }

    var number = Number(value);

    if (
      !Number.isInteger(number) ||
      number < 0 ||
      number > 99
    ) {
      setMessage(
        'Usa una cantidad entera entre 0 y 99.'
      );

      render();
      return;
    }

    var variant = find(
      type,
      colorFor(type)
    );

    if (
      number > state.quantities[type] &&
      (!variant || !variant.available)
    ) {
      return;
    }

    state.quantities[type] = number;

    if (type === 'back') {
      state.backExpanded = true;
    }

    setMessage(
      recovery ? recovery.message : ''
    );

    render();

    var selectionState = selection();

    announce(
      selectionState.count +
      ' fundas seleccionadas. Total productos ' +
      money(selectionState.total) +
      '.'
    );
  }

  function chooseQuantityFocus() {
    var target = q(
      '[data-fm-piece="seat"]'
    );

    target.scrollIntoView({
      block: 'center',
      behavior: window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
        ? 'auto'
        : 'smooth'
    });

    q('[data-fm-qty="seat"]').focus({
      preventScroll: true
    });
  }

  function showCart(result) {
    try {
      if (
        cartUI &&
        cartUI.tagName.toLowerCase() ===
          'cart-drawer' &&
        result.addResponse &&
        result.addResponse.sections &&
        typeof cartUI.renderContents ===
          'function'
      ) {
        var required =
          typeof cartUI.getSectionsToRender ===
          'function'
            ? cartUI
                .getSectionsToRender()
                .map(function (part) {
                  return part.id;
                })
            : sections;

        if (
          required.every(function (id) {
            return (
              typeof result.addResponse
                .sections[id] === 'string'
            );
          })
        ) {
          try {
            cartUI.classList.remove(
              'is-empty'
            );

            var inner =
              cartUI.querySelector(
                '.drawer__inner'
              );

            if (inner) {
              inner.classList.remove(
                'is-empty'
              );
            }

            cartUI.renderContents(
              result.addResponse
            );

            return;
          } catch (error) {}
        }
      }
    } catch (error) {}

    try {
      window.location.assign(
        q('[data-fm-cart-link]').href
      );
    } catch (error) {
      setMessage(
        'Tus fundas ya están en el carrito. Ábrelo para revisarlas.'
      );

      q('[data-fm-recovery]').hidden =
        false;

      q('[data-fm-recheck]').hidden =
        true;

      reviewed.hidden = true;
    }
  }

  function consumeResult(
    result,
    openCart
  ) {
    if (result.status === 'confirmed') {
      recovery = null;
      setMessage('');

      announce(
        openCart
          ? 'Tus fundas se agregaron al carrito.'
          : 'Carrito comprobado. Puedes cambiar tu selección o agregar más fundas.'
      );

      render();

      if (openCart) {
        showCart(result);
      }
    } else {
      recovery = result.pending
        ? result
        : null;

      setMessage(
        result.message ||
        'No pudimos confirmar la selección. Comprueba tu carrito.'
      );

      render();
    }
  }

  async function submitSelection() {
    if (busy || destroyed) {
      return;
    }

    if (
      recovery ||
      cart.loadPending()
    ) {
      await checkPending();
      return;
    }

    var selectionState = selection();

    if (selectionState.errors.length) {
      setMessage(
        selectionState.errors.join(' ')
      );

      return;
    }

    if (!selectionState.count) {
      chooseQuantityFocus();
      return;
    }

    busy = true;
    var generation = ++epoch;
    setMessage('');

    try {
      if (
        cartUI &&
        typeof cartUI.setActiveElement ===
          'function'
      ) {
        cartUI.setActiveElement(
          q('[data-fm-submit]')
        );
      }
    } catch (error) {}

    render();

    try {
      var result = await cart.add(
        selectionState.lines.map(
          function (line) {
            return {
              id: Number(line.variant.id),
              quantity: line.quantity
            };
          }
        )
      );

      if (
        generation !== epoch ||
        destroyed
      ) {
        return;
      }

      busy = false;

      if (result.status === 'confirmed') {
        emit('td_funda_builder_added', {
          product_handle: config.handle,
          builder_mode: 'unit',
          units: selectionState.count,
          value:
            selectionState.total / 100,
          currency: config.currency,

          pieces:
            selectionState.lines.map(
              function (line) {
                return {
                  piece:
                    'Funda de ' +
                    labels[line.type],
                  color: line.color,
                  units: line.quantity,
                  variant_id:
                    line.variant.id
                };
              }
            )
        });
      }

      consumeResult(result, true);
    } catch (error) {
      if (
        generation !== epoch ||
        destroyed
      ) {
        return;
      }

      busy = false;

      recovery = cart.loadPending()
        ? {
            message:
              'Comprueba tu carrito antes de volver a agregar.'
          }
        : null;

      setMessage(
        'No pudimos confirmar la selección. Comprueba tu carrito antes de volver a agregar.'
      );

      render();
    }
  }

  async function checkPending() {
    if (busy || destroyed) {
      return;
    }

    var pending = cart.loadPending();

    if (!pending) {
      recovery = null;
      setMessage('');
      render();
      return;
    }

    var generation = ++epoch;
    busy = true;
    render();

    q('[data-fm-submit]').textContent =
      'Comprobando carrito…';

    try {
      var result =
        await cart.reconcile(pending);

      if (
        destroyed ||
        generation !== epoch
      ) {
        return;
      }

      busy = false;
      consumeResult(result, false);
    } catch (error) {
      if (
        destroyed ||
        generation !== epoch
      ) {
        return;
      }

      busy = false;

      recovery = {
        message:
          'No pudimos comprobar el carrito. Revisa su contenido antes de continuar.'
      };

      setMessage(recovery.message);
      render();
    }
  }

  function onClick(event) {
    var target =
      event.target.closest('button');

    if (
      !target ||
      !root.contains(target) ||
      target.disabled
    ) {
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-guide-open'
      )
    ) {
      guideOpener = target;

      if (
        typeof guide.showModal ===
        'function'
      ) {
        guide.showModal();
      } else {
        guide.setAttribute('open', '');
      }

      refreshSticky();
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-guide-close'
      )
    ) {
      if (
        typeof guide.close === 'function'
      ) {
        guide.close();
      } else {
        guide.removeAttribute('open');
      }

      if (guideOpener) {
        guideOpener.focus({
          preventScroll: true
        });
      }

      refreshSticky();
      return;
    }

    if (busy) {
      return;
    }

    if (
      target.hasAttribute('data-fm-color')
    ) {
      state.color =
        target.dataset.fmColor;

      setMessage(
        recovery ? recovery.message : ''
      );

      render();
      gallery.setColor(
        colorFor('seat')
      );

      return;
    }

    if (
      target.hasAttribute('data-fm-step')
    ) {
      var parts =
        target.dataset.fmStep.split(':');

      setQuantity(
        parts[0],
        state.quantities[parts[0]] +
        Number(parts[1])
      );

      return;
    }

    if (
      target.hasAttribute(
        'data-fm-seat-count'
      )
    ) {
      setQuantity(
        'seat',
        target.dataset.fmSeatCount
      );

      return;
    }

    if (
      target.hasAttribute(
        'data-fm-other-qty'
      )
    ) {
      q('[data-fm-qty="seat"]').focus();
      q('[data-fm-qty="seat"]').select();
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-edit-backs'
      )
    ) {
      state.backExpanded = true;
      render();

      q('[data-fm-qty="back"]').focus({
        preventScroll: true
      });

      return;
    }

    if (
      target.hasAttribute(
        'data-fm-remove-backs'
      )
    ) {
      state.quantities.back = 0;
      state.backExpanded = false;

      setMessage(
        recovery ? recovery.message : ''
      );

      render();
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-add-backs'
      )
    ) {
      var amount = Math.max(
        1,
        Math.min(
          99,
          state.quantities.seat +
          state.quantities.chaise
        )
      );

      setQuantity('back', amount);

      emit(
        'td_funda_atf_backs_selected',
        {
          units: amount
        }
      );

      return;
    }

    if (
      target.hasAttribute(
        'data-fm-submit'
      )
    ) {
      submitSelection();
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-sticky-submit'
      )
    ) {
      if (
        recovery ||
        selection().errors.length
      ) {
        q('[data-fm-submit]')
          .scrollIntoView({
            block: 'center'
          });

        return;
      }

      submitSelection();
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-recheck'
      )
    ) {
      checkPending();
      return;
    }

    if (
      target.hasAttribute(
        'data-fm-reviewed'
      )
    ) {
      ++epoch;
      cart.clearPending();
      recovery = null;
      setMessage('');
      render();

      announce(
        'Puedes ajustar la selección. El próximo clic agregará las cantidades indicadas como una nueva compra.'
      );
    }
  }

  function onChange(event) {
    var target = event.target;

    if (busy) {
      return;
    }

    if (
      target.hasAttribute('data-fm-qty')
    ) {
      setQuantity(
        target.dataset.fmQty,
        target.value
      );
    }

    if (
      target.hasAttribute(
        'data-fm-custom'
      )
    ) {
      state.overrides[
        target.dataset.fmCustom
      ] = target.value;

      setMessage(
        recovery ? recovery.message : ''
      );

      render();

      if (
        target.dataset.fmCustom ===
        'seat'
      ) {
        gallery.setColor(
          colorFor('seat')
        );
      }
    }
  }

  function onPageShow() {
    if (destroyed) {
      return;
    }

    render();

    if (!busy) {
      checkPending();
    }
  }

  function listen(
    node,
    name,
    handler,
    options
  ) {
    node.addEventListener(
      name,
      handler,
      options
    );

    cleanups.push(function () {
      node.removeEventListener(
        name,
        handler,
        options
      );
    });
  }

  listen(root, 'click', onClick);
  listen(root, 'change', onChange);
  listen(guide, 'close', scheduleSticky);

  listen(
    window,
    'scroll',
    scheduleSticky,
    {
      passive: true
    }
  );

  listen(
    window,
    'resize',
    scheduleSticky,
    {
      passive: true
    }
  );

  listen(
    window,
    'pageshow',
    onPageShow
  );

  listen(
    window,
    'pagehide',
    saveState
  );

  root.dataset.fmMounted = 'true';

  root.fmDestroy = function () {
    destroyed = true;
    ++epoch;

    cleanups.forEach(
      function (cleanup) {
        cleanup();
      }
    );

    gallery.destroy();
    clearTimeout(announcementTimer);

    window.cancelAnimationFrame(
      scrollFrame
    );

    delete root.dataset.fmMounted;
  };

  q('[data-fm-ui]').hidden = false;
  q('[data-fm-fallback]').hidden = true;

  if (state.quantities.chaise) {
    q(
      '[data-fm-chaise-details]'
    ).open = true;
  }

  if (
    types.some(function (type) {
      return !!state.overrides[type];
    })
  ) {
    q(
      '[data-fm-custom-colors]'
    ).open = true;
  }

  render();
  gallery.setColor(colorFor('seat'));
  checkPending();
}

function initFundaATF(scope) {
  (scope || document)
    .querySelectorAll('[data-td-fm-atf]')
    .forEach(function (root) {
      try {
        mountFundaATF(root);
      } catch (error) {
        console.error(
          '[THE DOGS Funda ATF]',
          error
        );

        var fallback =
          root.querySelector(
            '[data-fm-fallback]'
          );

        var ui =
          root.querySelector(
            '[data-fm-ui]'
          );

        if (fallback) {
          fallback.hidden = false;
        }

        if (ui) {
          ui.hidden = true;
        }
      }
    });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initFundaATF();
    },
    {
      once: true
    }
  );
} else {
  initFundaATF();
}

document.addEventListener(
  'shopify:section:load',
  function (event) {
    initFundaATF(event.target);
  }
);

document.addEventListener(
  'shopify:section:unload',
  function (event) {
    event.target
      .querySelectorAll(
        '[data-td-fm-atf]'
      )
      .forEach(function (root) {
        if (root.fmDestroy) {
          root.fmDestroy();
        }
      });
  }
);

})();